var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"common-link--set-currency a",class:_vm.getClass,on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.link.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }